const STATE_UP = 'UP';
const STATE_DOWN = 'DOWN';

export default class Slideable {

	constructor(element, duration = 300) {
		this.element = element;
		this.duration = duration;
		this.originalStyle = {};
		this.originalDisplay = null;
		this.state = STATE_UP;
	}

	_prepare() {
		this._calculateSize();

		Object.assign(this.originalStyle, this.element.style);
		this.originalDisplay = window.getComputedStyle(this.element).display;

		Object.assign(
			this.element.style,
			{
				overflow: 'hidden',
				transition: `height ${this.duration}ms cubic-bezier(0.37, 0, 0.63, 1)`,
			},
		);
	}

	_finalize() {
		this.element.style = this.originalStyle;

		if (this.state === STATE_UP && this.isHidden())
			this.element.style.display = 'block';

		if (this.state === STATE_DOWN && !this.isHidden())
			this.element.style.display = 'none';
	}

	_calculateSize() {
		let display = window.getComputedStyle(this.element).display;
		if (this.isHidden()) {
			this.element.style.display = 'block';
		}
		this.height = this.element.getBoundingClientRect().height;
		this.element.style.display = display;
	}

	down(callbackUp = null) {
		if (typeof callbackUp === 'function') callbackUp();

		this.state = STATE_UP;
		this._prepare();

		this.element.style.height = '0';
		this.element.style.display = this.originalDisplay === 'none' ? 'block' : this.originalDisplay;

		setTimeout(() => {
			this.element.style.height = this.height + 'px';
		}, 10);

		setTimeout(() => {
			this._finalize();
		}, this.duration + 10);
	}

	up(callbackDown = null) {
		this.state = STATE_DOWN;
		this._prepare();
		this.element.style.height = this.height + 'px';

		setTimeout(() => {
			this.element.style.height = 0;
		}, 10);

		setTimeout(() => {
			this.element.style.display = 'none';
			this._finalize();
		}, this.duration + 10);

		if (typeof callbackDown === 'function') callbackDown();
	}

	toggle(callbackUp = null, callbackDown = null) {
		if (this.isHidden()) return this.down(callbackUp);
		else this.up(callbackDown);
	}

	isHidden() {
		return window.getComputedStyle(this.element).display === 'none';
	}
}
